import { render, staticRenderFns } from "./base-client-search.vue?vue&type=template&id=f524a51e"
import script from "./base-client-search.vue?vue&type=script&lang=js"
export * from "./base-client-search.vue?vue&type=script&lang=js"
import style0 from "./base-client-search.vue?vue&type=style&index=0&id=f524a51e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports